module.exports = __webpack_public_path__ + "img/icon-success2.d05bcb6c.png";